export default {
  allCell: {
    width: '60px'
  },
  invitedCell: {
    textAlign: 'left',
    width: '115px'
  },
  titleCell: {
    textAlign: 'left'
  },
  fromCell: {
    textAlign: 'left',
    width: '20%'
  },
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  }
}
